import { render, staticRenderFns } from "./GlobalAddSpecialPriceModal.vue?vue&type=template&id=e55207ca&scoped=true&"
import script from "./GlobalAddSpecialPriceModal.vue?vue&type=script&lang=js&"
export * from "./GlobalAddSpecialPriceModal.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAddSpecialPriceModal.vue?vue&type=style&index=0&id=e55207ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55207ca",
  null
  
)

export default component.exports